const childrenLoaded = require('@alexspirgel/children-loaded');
const TextBlockFormat = require("../../../../js/modules/module-text");
class PullQuote extends HTMLDivElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    await childrenLoaded(this);
    this.initialize();
  }

  wrap(element, wrapperElement) {
    element.parentNode.insertBefore(wrapperElement, element);
    wrapperElement.appendChild(element);
  }

  async initialize() {
    await childrenLoaded(this);
    if (this.initialized) {
      return;
    }
    this.initialized = true;
    TextBlockFormat(this);
  }
}
customElements.define('pull-quote', PullQuote, { extends: 'div' });
